import React, { useState } from "react";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";
import Alteration from "../../model/Alteration";

interface IAlterationsListElementProps {
  data: Alteration;
  canEdit: boolean;
  onUpdate: (name: string, id: number, type: string) => void;
  onDelete: (id: number, type: string) => void;
}

function AlterationsListElement({
  data,
  canEdit,
  onUpdate,
  onDelete,
}: IAlterationsListElementProps) {
  // Local state for the editable name
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(data.name);

  // Toggle edit mode
  const handleEditClick = () => {
    if (!canEdit) return;
    setIsEditing(true);
  };

  const handleDelete = () => {
    if (!data.id) return;
    onDelete(data.id, "alteration");
  };

  // Handle saving the updated name
  const handleEdit = (e?: React.KeyboardEvent<HTMLInputElement>) => {
    if (!e || e.key === "Enter") {
      setIsEditing(false);
      if (data.id && data.name !== name) {
        onUpdate(name, data.id, "alteration");
      }
    }
  };

  return (
    <div className="alteration">
      <div className="alteration-inner">
        {/* Left Column */}
        <div className="alteration-title">
          {/* Toggle between text and input field */}
          {isEditing ? (
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onBlur={() => handleEdit()}
              onKeyDown={handleEdit}
              autoFocus
            />
          ) : (
            <h3 onClick={handleEditClick}>{data.name}</h3>
          )}
        </div>

        {/* Right Column */}
        {canEdit && (
          <div>
            <Button
              label="Edit"
              purpose={ButtonAction.EDIT}
              type={ButtonType.ICON}
              onClick={handleEditClick}
            />
            <Button
              label="Delete"
              purpose={ButtonAction.DELETE}
              type={ButtonType.ICON}
              onClick={handleDelete}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default AlterationsListElement;
